import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=7fb0b5dc&scoped=true&"
import script from "./ServerError.js?vue&type=script&lang=js&"
export * from "./ServerError.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=7fb0b5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0b5dc",
  null
  
)

/* custom blocks */
import block0 from "./ServerError.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcommon%2Fform%2FServerError%2FServerError.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports